import { AddressInput } from '@dealstack/frontend/shared/components/forms/AddressInput/AddressInput';
import { PhoneNumberInput } from '@dealstack/frontend/shared/components/forms/PhoneNumberInput/PhoneNumberInput';
import { Button } from '@dealstack/frontend/shared/components/fundament/Button/Button';
import { FullscreenLoader } from '@dealstack/frontend/shared/components/loaders/FullLoaderScreenLoader/FullLoaderScreenLoader';
import { MantineDateInput } from '@dealstack/frontend/shared/components/mantineForm/MantineDateInput';
import { SectionHeader } from '@dealstack/frontend/shared/components/SectionHeader/SectionHeader';
import { Flex } from '@mantine/core';
import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import {
	ActionButton,
	DeleteButton,
	Inputlabel,
	PersonalInputsWrapper,
} from '@dealstack/frontend/admin/pages/Manage/User/ManageInvestorPersonalDetails/styled';
import {
	INVESTOR_PERSONAL_INFO_FORM,
	useManageInvestorPersonalDetailsController,
} from './useManageInvestorPersonalDetailsController';

interface Props {
	className?: string;
}

const ManageInvestorPersonalDetails = ({ className }: Props) => {
	const { createInvestorPersonalDetailsForm, onSubmit, userId, isLoading, onClearSubmit } =
		useManageInvestorPersonalDetailsController();

	if (isLoading) {
		return <FullscreenLoader name="pageLoading" />;
	}
	return (
		<div className={className}>
			<Link to={`../investor/${userId}`}>
				<Button variant="project">Back to investor</Button>
			</Link>
			<br />
			<SectionHeader title="Investor personal details" />
			<FormProvider {...createInvestorPersonalDetailsForm}>
				<form onSubmit={createInvestorPersonalDetailsForm.handleSubmit(onSubmit)}>
					<PersonalInputsWrapper>
						<AddressInput
							countryFieldName={INVESTOR_PERSONAL_INFO_FORM.COUNTRY}
							cityFieldName={INVESTOR_PERSONAL_INFO_FORM.CITY}
							postCodeFieldName={INVESTOR_PERSONAL_INFO_FORM.POST_CODE}
							streetFieldName={INVESTOR_PERSONAL_INFO_FORM.STREET}
							houseNumberFieldName={INVESTOR_PERSONAL_INFO_FORM.HOUSE_NUMBER}
						/>
						<Flex gap="sm">
							<div className="w-[100%]">
								<PhoneNumberInput
									name={INVESTOR_PERSONAL_INFO_FORM.PHONE_NUMBER}
									phonePrefixName={INVESTOR_PERSONAL_INFO_FORM.TELEPHONE_PREFIX}
									label={<Inputlabel>Phone number</Inputlabel>}
									size="m"
								/>
							</div>
							<div className="w-[100%]">
								<MantineDateInput
									labelProps={{ className: 'date-input-label' }}
									name={INVESTOR_PERSONAL_INFO_FORM.BIRTH_DATE}
									maxDate={new Date()}
									label={<Inputlabel>DATE OF BIRTH</Inputlabel>}
									size="sm"
									placeholder="Enter date of birth"
								/>
							</div>
						</Flex>

						{/*TODO PersonHarmonization, temporary disabled until we have redesigned frontend for multiple PIV's d.zghinnik 4.07.2025*/}
						{/*<Text mt="md" size="B5Bold">*/}
						{/*	Investment vehicle details*/}
						{/*</Text>*/}
						{/*<Text mt={0} size="B5Medium">*/}
						{/*	Company details*/}
						{/*</Text>*/}
						{/*<StringInput label="Company name" name={PIV_FORM.PIV_NAME} />*/}
						{/*<StringInput label="Company number" name={PIV_FORM.PIV_REG_NUMBER} />*/}
						{/*<AddressInput*/}
						{/*	countryFieldName={PIV_FORM.PIV_COUNTRY}*/}
						{/*	cityFieldName={PIV_FORM.PIV_CITY}*/}
						{/*	postCodeFieldName={PIV_FORM.PIV_POST_CODE}*/}
						{/*	streetFieldName={PIV_FORM.PIV_STREET}*/}
						{/*	houseNumberFieldName={PIV_FORM.PIV_HOUSE_NUMBER}*/}
						{/*/>*/}

						{/*<Text mt="sm" size="B5Medium">*/}
						{/*	Legal representative*/}
						{/*</Text>*/}
						{/*<StringInput label="First name" name={LEGAL_REP_FORM.REP_FIRST_NAME} />*/}
						{/*<StringInput label="Last name" name={LEGAL_REP_FORM.REP_LAST_NAME} />*/}
						{/*<StringInput label="Email address" name={LEGAL_REP_FORM.REP_EMAIL} />*/}

						{/*<Flex gap="sm">*/}
						{/*	<div className="w-[100%]">*/}
						{/*		<PhoneNumberInput*/}
						{/*			name={LEGAL_REP_FORM.REP_PHONE_NUMBER}*/}
						{/*			phonePrefixName={LEGAL_REP_FORM.REP_TELEPHONE_PREFIX}*/}
						{/*			label={<Inputlabel>Phone number</Inputlabel>}*/}
						{/*			size="m"*/}
						{/*		/>*/}
						{/*	</div>*/}

						{/*	<div className="w-[100%]">*/}
						{/*		<MantineDateInput*/}
						{/*			labelProps={{ className: 'date-input-label' }}*/}
						{/*			name={LEGAL_REP_FORM.REP_BIRTH_DATE}*/}
						{/*			maxDate={new Date()}*/}
						{/*			label={<Inputlabel>DATE OF BIRTH</Inputlabel>}*/}
						{/*			size="sm"*/}
						{/*			placeholder="Enter date of birth"*/}
						{/*		/>*/}
						{/*	</div>*/}
						{/*</Flex>*/}

						{/*<AddressInput*/}
						{/*	countryFieldName={LEGAL_REP_FORM.REP_COUNTRY}*/}
						{/*	cityFieldName={LEGAL_REP_FORM.REP_CITY}*/}
						{/*	postCodeFieldName={LEGAL_REP_FORM.REP_POST_CODE}*/}
						{/*	streetFieldName={LEGAL_REP_FORM.REP_STREET}*/}
						{/*	houseNumberFieldName={LEGAL_REP_FORM.REP_HOUSE_NUMBER}*/}
						{/*/>*/}
						<ActionButton variant="secondary" buttonType="submit">
							Update
						</ActionButton>
					</PersonalInputsWrapper>
				</form>
			</FormProvider>
			<DeleteButton variant="delete" buttonType="submit" onClick={onClearSubmit}>
				Clear
			</DeleteButton>
		</div>
	);
};

const Memoized = memo(ManageInvestorPersonalDetails);
const Styled = styled(Memoized)`
	form {
		margin-top: 1rem;
	}

	.mantine-Input-input,
	.PhoneInput {
		border-color: #a7b0b5;
	}
`;

export { Styled as ManageInvestorPersonalDetails };
